/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c552c281 (Wed Jul  1 16:38:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum EnrollmentDiscountCode {
  _1Pp = '1PP',
  Max3S = 'MAX3S',
}

export function EnrollmentDiscountCodeFromJSON(
  json: any
): EnrollmentDiscountCode {
  return EnrollmentDiscountCodeFromJSONTyped(json, false)
}

export function EnrollmentDiscountCodeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EnrollmentDiscountCode {
  return json as EnrollmentDiscountCode
}

export function EnrollmentDiscountCodeToJSON(
  value?: EnrollmentDiscountCode | null
): any {
  return value as any
}
